/**
 * Local formatters for pricing-v2.
 *
 * `formatCurrency` / `formatNumber` kept module-local so the pricing-v2
 * surface stays self-contained without touching unrelated shared files.
 */

import { toNumberOrNull } from '../utils/loanValueHelpers';

/** Format a numeric value to fixed decimals (default 2). '-' on blank / non-numeric. */
export function formatNumber(value: unknown, decimals: number = 2): string {
  const n = toNumberOrNull(value);
  return n !== null ? n.toFixed(decimals) : '-';
}

/** Format USD currency with no cents (e.g. "$1,500,000"). '-' on blank / non-numeric. */
export function formatCurrency(value: unknown): string {
  const n = toNumberOrNull(value);
  if (n === null) {
    return '-';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(n);
}
